import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers} from 'redux';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configReducer from './store/Reducers/ConfigReducer';
import displayReducer from './store/Reducers/DisplayReducer';
import axios from 'axios';
import { composeWithDevTools } from '@redux-devtools/extension';
import  { setLayerHostSelector }  from '@fluentui/react';

axios.defaults.baseURL = process.env.REACT_APP_LIMS_API_BASE_URL;

setLayerHostSelector('body');

const rootReducer = combineReducers({
  config: configReducer,
  display: displayReducer
});

const store = createStore(rootReducer, composeWithDevTools());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

